import type { CheckStatus } from '@numistic/contracts'
import { useReadiness } from '@numistic/data'
import { useTranslation } from '@numistic/i18n'
import { cn } from '@numistic/ui'

type State = CheckStatus | 'loading' | 'unreachable'

const COLORS: Record<State, string> = {
  ok: 'bg-success',
  degraded: 'bg-warning',
  fail: 'bg-destructive',
  loading: 'bg-muted-foreground',
  unreachable: 'bg-destructive',
}

export function ApiStatus() {
  const { t } = useTranslation()
  const { data, isPending, isError } = useReadiness()
  const state: State = isPending ? 'loading' : isError ? 'unreachable' : data.status
  // Всё в порядке — индикатор не нужен; показываем только проблемы со связью или сервером.
  if (state === 'ok' || state === 'loading' || state === 'degraded') return null
  return (
    <span
      className="inline-flex items-center gap-2 text-xs text-muted-foreground"
      role="status"
      title={data?.version}
    >
      <span className={cn('size-2 rounded-full', COLORS[state])} aria-hidden />
      <span className="sr-only sm:not-sr-only">{t(`status.${state}`)}</span>
    </span>
  )
}
